import type { ScreenSchema } from './types';
// Dashboard content comes mostly from injected store data, not screen-level fields.
// The intro slot is defined for completeness; JiT text will be empty if no screen.heading exists.
// S3 intro audio still resolves correctly via screen.id key.
const dashboardSchema: ScreenSchema = {
  template: ['dashboard', 'subunit-dashboard', 'dashboard-video'],
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
  }
};
export default dashboardSchema;
